import { ExclamationCircleGray300Icon } from '@assets/iconComponents';
import { Text } from '..';
import { colorSet } from '@theme';
import { Button } from '@mui/material';
import { useNavigate } from 'react-router';

// 존재하지 않는 주소로 접근시 보여줌
export const NotFoundElement = () => {
  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate(-1); // 브라우저 히스토리 한 단계 뒤로
  };

  return (
    <div style={{ width: '100vw', height: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '24px', alignItems: 'center' }}>
        <ExclamationCircleGray300Icon style={{ width: 60, height: 60 }} />
        <Text variant="h3" color={colorSet.gray500}>
          존재하지 않는 페이지입니다.
        </Text>
        <Text variant="body1" color={colorSet.gray400}>
          존재하지 않는 주소를 입력하셨거나, 요청하신 페이지의 주소가 변경 또는 삭제되었습니다.
        </Text>
        <Button onClick={handleGoBack} variant="outlined" color="secondary">
          돌아가기
        </Button>
      </div>
    </div>
  );
};
